import { authenticatedFetchJson } from "@/services/utils/authenticatedFetch";

interface CreditsResponse {
  credits: string;
  type?: "consumed" | "remaining";
}

export async function fetchCredits(): Promise<CreditsResponse> {
  const data = await authenticatedFetchJson<CreditsResponse>("/api/heygen/credits");
  return data;
}
